import React, { ReactNode } from 'react';
import classNames from 'classnames';
import styles from './NewSidebarHeader.module.css';
import { FreeTrialCountdown } from '../../FreeTrialCountdown/FreeTrialCountdown';

type Props = {
  children: ReactNode;
  isFreeTrialActive?: boolean;
};

export const NewSidebarHeader = (props: Props) => {
  const { children, isFreeTrialActive } = props;

  return (
    <div
      className={classNames(styles.wrapper, {
        [styles.wrapperWithTrial]: isFreeTrialActive,
      })}
    >
      <div className={styles.header}>
        <div className={styles.leftSide}>{children}</div>
      </div>
    </div>
  );
};
